<mat-nav-list appAccordion>
  @if (isInAdmin) {
    <div class="back-to-home-container">
      <app-ui-button
        buttonType="mat"
        text="{{ 'exitAdmin' | translate }}"
        icon="arrow_circle_left"
        routerLink="/"
        (click)="exitAdmin()"
      ></app-ui-button>
    </div>
  }
  <div class="main-modules-section" [ngClass]="isInAdmin ? 'admin-main-modules-section' : ''">
    @for (mainSection of mainMenuItems; track $index) {
      <div
        class="main-section"
        [ngClass]="
          mainSection.name === 'productOwner' || mainSection.name === 'other'
            ? 'bottom-main-section'
            : ''
        "
      >
        <div>
          <h5>{{ mainSection.name | translate | uppercase }}</h5>
          <app-menu-list-recursive
            [navItems]="mainSection.children"
            [currentTenantId]="currentTenantId"
            [currentMenuState]="currentMenuState"
            [isInAdmin]="isInAdmin"
            [dueListWarningsExpiredSum]="expiredWarnings"
            [dueListWarningsExpiringSum]="soonExpiringWarnings"
            [currentlyAvailableModules]="currentlyAvailableModules"
          ></app-menu-list-recursive>
        </div>
      </div>
    }
  </div>
</mat-nav-list>
